(function (window, document) {
  'use strict';

  var TRACKED_ATTR = 'data-lum-content-track';
  var TRACKED_SELECTOR = '[' + TRACKED_ATTR + ']';

  var EVENT_IDS = {
    CARD: 'allos_content_card_click',
    SEEALL: 'allos_content_seeall_click',
    DETAIL: 'allos_content_detail_view',
    CINEMA_THEATER_CARD: 'allos_cinema_theater_card_click',
    CINEMA_THEATER_SEEALL: 'allos_cinema_theater_seeall_click',
    CINEMA_THEATER_DETAIL: 'allos_cinema_theater_detail_view',
  };

  var ACTION_TO_EVENT_ID = {
    generic: {
      card: EVENT_IDS.CARD,
      seeall: EVENT_IDS.SEEALL,
      detail: EVENT_IDS.DETAIL,
    },
    cinemaTheater: {
      card: EVENT_IDS.CINEMA_THEATER_CARD,
      seeall: EVENT_IDS.CINEMA_THEATER_SEEALL,
      detail: EVENT_IDS.CINEMA_THEATER_DETAIL,
    },
  };

  var ALLOWED_TYPES = {
    event: true,
    stayupdated: true,
    cinema: true,
    teatro: true,
  };

  function normalizeContentType(type) {
    if (!type || typeof type !== 'string') {
      return '';
    }
    return type.toLowerCase();
  }

  function isCinemaTheaterType(type) {
    return type === 'cinema' || type === 'teatro';
  }

  function prefixedContentName(type, name) {
    var safeName = name == null ? '' : String(name);
    if (!safeName) {
      return safeName;
    }

    if (type === 'cinema') {
      return '[Cinema] ' + safeName;
    }

    if (type === 'teatro') {
      return '[Teatro] ' + safeName;
    }

    return safeName;
  }

  function buildPayload(type, name) {
    var safeName = name == null ? '' : name;
    if (isCinemaTheaterType(type)) {
      return {
        cinema_theater_type: type,
        cinema_theater_name: prefixedContentName(type, safeName),
      };
    }

    return {
      type: type,
      content_name: safeName,
    };
  }

  function getEventId(action, type) {
    var eventMap = isCinemaTheaterType(type)
      ? ACTION_TO_EVENT_ID.cinemaTheater
      : ACTION_TO_EVENT_ID.generic;

    return action ? eventMap[action] : null;
  }

  function isLumTrackReady() {
    return typeof window.lum_track === 'function';
  }

  function safeLumTrack(eventId, data) {
    if (!isLumTrackReady()) {
      return;
    }
    try {
      window.lum_track('event', eventId, data);
    } catch (e) {
      /* CTRACK-06: fail silently */
    }
  }

  function onDocumentClick(event) {
    var t = event.target;
    if (!t || !t.closest) {
      return;
    }

    var root = t.closest(TRACKED_SELECTOR);
    if (!root) {
      return;
    }

    var type = normalizeContentType(root.getAttribute('data-lum-content-type'));
    if (!type || !ALLOWED_TYPES[type]) {
      return;
    }

    var action = root.getAttribute('data-lum-content-action');
    var eventId = getEventId(action, type);
    if (!eventId) {
      return;
    }

    var name = root.getAttribute('data-lum-content-name');
    safeLumTrack(eventId, buildPayload(type, name));

    if (type === 'cinema' && action === 'card') {
      event.__lumCinemaTracked = true;
    }
  }

  function trackPageDetailViews() {
    var nodes = document.querySelectorAll('[data-lum-content-track-page]');
    if (!nodes || !nodes.length) {
      return;
    }

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var type = normalizeContentType(node.getAttribute('data-lum-content-type'));
      if (!type || !ALLOWED_TYPES[type]) {
        continue;
      }

      var action = node.getAttribute('data-lum-content-action');
      var eventId = getEventId(action, type);
      if (!eventId) {
        continue;
      }

      var name = node.getAttribute('data-lum-content-name');
      safeLumTrack(eventId, buildPayload(type, name));
    }
  }

  function bootstrap() {
    document.addEventListener('click', onDocumentClick, true);
    trackPageDetailViews();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})(window, document);
